module.exports = __webpack_public_path__ + "img/mx_seguroportatil.e434655f.png";